import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

export const sessionVideosQueryKey = (sessionId: string) =>
  ["sessions", sessionId, "videos"] as const;

export function useSessionVideos(sessionId: string) {
  const query = useQuery({
    queryKey: sessionVideosQueryKey(sessionId),
    queryFn: () => apiClient.getSessionVideos(sessionId),
    enabled: !!sessionId,
  });

  const videos = useMemo(() => query.data?.videos ?? [], [query.data]);

  return {
    videos,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
